import {
    ACT_CUR_PAGE,
  } from '../mutation_type';
  
  const state = {
    actCurPage: "list",
  };
  
  const getters = {
    getActCurPage: state => state.actCurPage,
  };
  
  const mutations = {
    [ ACT_CUR_PAGE ](state, actCurPage) {
      state.actCurPage = actCurPage;
    },
  };
  
  export default {
    state,
    getters,
    mutations,
  };
  